import { z } from "zod";

export const postLikeSchema = z.object({
	user_id: z.string(),
	first_name: z.string().nullable(),
	last_name: z.string().nullable(),
	photo_url: z.string().nullable(),
});

export type PostLike = z.infer<typeof postLikeSchema>;
